export const usePlanCodes = () => {
    const standardSubscriptionMonthlyPaystackPlanCode = import.meta.env.VITE_STANDARD_SUBSCRIPTION_MONTHLY_PAYSTACK_PLAN_CODE;
    const standardSubscriptionAnnualPaystackPlanCode = import.meta.env.VITE_STANDARD_SUBSCRIPTION_ANNUAL_PAYSTACK_PLAN_CODE;
    const enterpriseSubscriptionMonthlyPaystackPlanCode = import.meta.env.VITE_ENTERPRISE_SUBSCRIPTION_MONTHLY_PAYSTACK_PLAN_CODE;

    return {
        standardSubscriptionMonthlyPaystackPlanCode,
        standardSubscriptionAnnualPaystackPlanCode,
        enterpriseSubscriptionMonthlyPaystackPlanCode
    }
}